const collator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: 'base',
});

export function naturalStringCompare(
  a: string | null | undefined,
  b: string | null | undefined
) {
  return collator.compare(a ?? '', b ?? '');
}
